module.exports = __webpack_public_path__ + "img/5_fineStaff_df.6d3bfb4c.png";